const AlarmNames = [
    "CommunicationFault",
    "CLF_CellVoltage",
    "CLF_T",
    "CurrentCollectorFault",
    "CellVoltageDiffExcess",
    "CellVoltageOver",
    "CellVoltageUnder",
    "VoltageOver",
    "VoltageUnder",
    "T_DiffExcess",
    "T_Over",
    "T_Under",
    "OverCurrentCharge",
    "OverCurrentDischarge",
    "SOCLower",
    "BattaryCollectorFault",
    "VoltageDiffExcess",
    "CapacityInconsistency",
    "Discharge_T_DiffExcess",
    "Discharge_T_Over",
    "Discharge_T_Under",
    "MOSTemperatureFault",
    "ContactRodTemperatureFault",
    "RelayOrMOSSticking",
    "InternalFault",
    "PowerVoltageOver",
    "PowerVoltageUnder",
    "InsulationResistanceLow",
    "InterPackBalancingFault",
    "HeatingFault",
];

const MapAlarmNameToCategorys = {
    "CommunicationFault":         1,
    "CLF_CellVoltage":            2,
    "CLF_T":                      3,
    "CurrentCollectorFault":      4,
    "CellVoltageDiffExcess":      5,
    "CellVoltageOver":            6,
    "CellVoltageUnder":           7,
    "VoltageOver":                8,
    "VoltageUnder":               9,
    "T_DiffExcess":               10,
    "T_Over":                     11,
    "T_Under":                    12,
    "OverCurrentCharge":          13,
    "OverCurrentDischarge":       14,
    "SOCLower":                   15,
    "BattaryCollectorFault":      16,
    "VoltageDiffExcess":          17,
    "CapacityInconsistency":      18,
    "Discharge_T_DiffExcess":     19,
    "Discharge_T_Over":           20,
    "Discharge_T_Under":          21,
    "MOSTemperatureFault":        22,
    "ContactRodTemperatureFault": 23,
    "RelayOrMOSSticking":         24,
    "InternalFault":              25,
    "PowerVoltageOver":           26,
    "PowerVoltageUnder":          27,
    "InsulationResistanceLow":    28,
    "InterPackBalancingFault":    29,
    "HeatingFault":               30,
}

const MapAlarmNameToName2 = {
    "CommunicationFault": "BMU Communication",
    "CLF_CellVoltage": "Cell Voltage Sensor Link",
    "CLF_T": "Temperature Sensor Link",
    "CurrentCollectorFault": "Current Sensor Link",
    "BattaryCollectorFault": "Battary Sensor",
    "T_DiffExcess": "Temperature Difference",
    "T_Over": "Temperature Over",
    "T_Under": "Temperature Under",
    "OverCurrentCharge": "Current Over",
    "CellVoltageDiffExcess": "Excessive Voltage Difference",
    "CellVoltageOver": "Voltage Over",
    "CellVoltageUnder": "Voltage Under",
    "PowerVoltageOver": "Power Voltage Over",
    "PowerVoltageUnder": "Power Voltage Under",
    "InsulationResistanceLow": "Insulation Resistance Low",
    "VoltageOver": "Total Voltage Over",
    "VoltageUnder": "Total Voltage Under",
    "SOCLower": "SOC",
    "VoltageDiffExcess": "Total Voltage Difference",
    "CapacityInconsistency": "Capacity Inconsistency",
    "MOSTemperatureFault": "MOS Temperature Fault",
    "ContactRodTemperatureFault": "ContactRod Temperature Fault",
    "RelayOrMOSSticking": "Relay or MOS Sticking",
    "InternalFault": "Internal Fault",
    "InterPackBalancingFault": "Inter-pack Balancing Fault",
    "HeatingFault": "Heating Fault",
    "Discharge_T_DiffExcess": "Temperature Difference",
    "Discharge_T_Over": "Temperature Over",
    "Discharge_T_Under": "Temperature Under",
    "OverCurrentDischarge": "Current Over"
}

export default {AlarmNames, MapAlarmNameToCategorys, MapAlarmNameToName2};
    